customElements.get("product-form") ||
  customElements.define(
    "product-form",
    class extends HTMLElement {
      constructor() {
        (super(),
          (this.originalButtonText = ""),
          (this.persistentTextActive = !1));
      }
      connectedCallback() {
        setTimeout(() => {
          if (((this.form = this.querySelector("form")), !this.form)) return;
          const t = this.variantIdInput;
          if (
            (t && (t.disabled = !1),
            this.form.addEventListener(
              "submit",
              this.onSubmitHandler.bind(this),
            ),
            (this.cart =
              document.querySelector("cart-notification") ||
              document.querySelector("cart-drawer")),
            (this.submitButton = this.querySelector('[type="submit"]')),
            this.submitButton)
          ) {
            if (
              ((this.submitButtonText =
                this.submitButton.querySelector(".button-text")),
              this.submitButtonText &&
                ((this.originalButtonText = this.submitButtonText.textContent),
                (this.submitButton.dataset.originalText =
                  this.originalButtonText)),
              "true" === this.submitButton.dataset.textOverride &&
                this.submitButtonText)
            );
            else if (
              this.submitButton.classList.contains("has-persistent-text") &&
              this.submitButtonText
            ) {
              this.persistentTextActive = !0;
              const t = this.submitButton.dataset.persistentText;
              if (t)
                ((this.submitButtonText.textContent = t),
                  localStorage.setItem("addToCartButtonText", t));
              else {
                const t = localStorage.getItem("addToCartButtonText");
                t &&
                  ((this.submitButtonText.textContent = t),
                  (this.submitButton.dataset.persistentText = t));
              }
            }
            ((this.persistentTextActive ||
              "true" === this.submitButton.dataset.textOverride) &&
              this.submitButtonText &&
              this.setupButtonTextObserver(),
              document.querySelector("cart-drawer") &&
                this.submitButton.setAttribute("aria-haspopup", "dialog"),
              (this.hideErrors = "true" === this.dataset.hideErrors),
              document.addEventListener(
                "variant:change",
                this.handleVariantChange.bind(this),
              ));
          }
        }, 100);
      }
      setupButtonTextObserver() {
        if (!this.submitButtonText) return;
        const t = { characterData: !0, childList: !0, subtree: !0 };
        if (this.persistentTextActive) {
          const e =
            this.submitButton.dataset.persistentText ||
            localStorage.getItem("addToCartButtonText");
          if (!e) return;
          ((this.buttonTextObserver = new MutationObserver((t) => {
            this.submitButtonText.textContent !== e &&
              (this.submitButtonText.textContent = e);
          })),
            this.buttonTextObserver.observe(this.submitButtonText, t));
        }
      }
      handleVariantChange(t) {
        this.submitButtonText &&
          setTimeout(() => {
            if (this.persistentTextActive) {
              const t =
                this.submitButton.dataset.persistentText ||
                localStorage.getItem("addToCartButtonText");
              t && (this.submitButtonText.textContent = t);
            }
          }, 50);
      }
      onSubmitHandler(t) {
        if (
          (t.preventDefault(),
          "true" === this.submitButton.getAttribute("aria-disabled"))
        )
          return;
        (this.handleErrorMessage(),
          this.submitButton.setAttribute("aria-disabled", !0),
          this.submitButton.classList.add("loading"),
          this.querySelector(".loading__spinner").classList.remove("hidden"));
        const e = fetchConfig("javascript");
        ((e.headers["X-Requested-With"] = "XMLHttpRequest"),
          delete e.headers["Content-Type"]);
        const s = new FormData(this.form);
        localStorage.setItem("toggleSwitch", "true");
        (this.cart &&
          (s.append(
            "sections",
            this.cart.getSectionsToRender().map((t) => t.id),
          ),
          s.append("sections_url", window.location.pathname),
          this.cart.setActiveElement(document.activeElement)),
          (e.body = s),
          fetch(`${routes.cart_add_url}`, e)
            .then((t) => t.json())
            .then((t) => {
              if (t.status) {
                (publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: s.get("id"),
                  errors: t.errors || t.description,
                  message: t.message,
                }),
                  this.handleErrorMessage(t.description));
                const e = this.submitButton.querySelector(".sold-out-message");
                if (!e) return;
                return (
                  this.submitButton.setAttribute("aria-disabled", !0),
                  this.submitButtonText.classList.add("hidden"),
                  e.classList.remove("hidden"),
                  void (this.error = !0)
                );
              }
              if (!this.cart)
                return void (window.location = window.routes.cart_url);
              const e = CartPerformance.createStartingMarker(
                "add:wait-for-subscribers",
              );
              (this.error ||
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: s.get("id"),
                  cartData: t,
                }).then(() => {
                  CartPerformance.measureFromMarker(
                    "add:wait-for-subscribers",
                    e,
                  );
                }),
                (this.error = !1));
              const i = this.closest("quick-add-modal");
              i
                ? (document.body.addEventListener(
                    "modalClosed",
                    () => {
                      setTimeout(() => {
                        CartPerformance.measure(
                          "add:paint-updated-sections",
                          () => {
                            this.cart.renderContents(t);
                          },
                        );
                      });
                    },
                    { once: !0 },
                  ),
                  i.hide(!0))
                : CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(t);
                  });
            })
            .catch((t) => {
              console.error(t);
            })
            .finally(() => {
              if (
                (this.submitButton.classList.remove("loading"),
                this.cart &&
                  this.cart.classList.contains("is-empty") &&
                  this.cart.classList.remove("is-empty"),
                this.error ||
                  this.submitButton.removeAttribute("aria-disabled"),
                this.querySelector(".loading__spinner").classList.add("hidden"),
                this.error || "true" !== this.submitButton.dataset.textOverride)
              ) {
                if (!this.error && this.persistentTextActive) {
                  const t =
                    this.submitButton.dataset.persistentText ||
                    localStorage.getItem("addToCartButtonText");
                  t &&
                    this.submitButtonText &&
                    (this.submitButtonText.textContent = t);
                }
              } else;
              CartPerformance.measureFromEvent("add:user-action", t);
            }));
      }
      handleErrorMessage(t = !1) {
        this.hideErrors ||
          ((this.errorMessageWrapper =
            this.errorMessageWrapper ||
            this.querySelector(".product-form__error-message-wrapper")),
          this.errorMessageWrapper &&
            ((this.errorMessage =
              this.errorMessage ||
              this.errorMessageWrapper.querySelector(
                ".product-form__error-message",
              )),
            this.errorMessageWrapper.toggleAttribute("hidden", !t),
            t && (this.errorMessage.textContent = t)));
      }
      toggleSubmitButton(t = !0, e) {
        if (t)
          (this.submitButton.setAttribute("disabled", "disabled"),
            e && (this.submitButtonText.textContent = e));
        else {
          if (
            (this.submitButton.removeAttribute("disabled"),
            "true" === this.submitButton.dataset.textOverride)
          );
          else if (this.persistentTextActive) {
            const t =
              this.submitButton.dataset.persistentText ||
              localStorage.getItem("addToCartButtonText");
            if (t) return void (this.submitButtonText.textContent = t);
          }
          this.originalButtonText
            ? (this.submitButtonText.textContent = this.originalButtonText)
            : this.submitButton.dataset.originalText
              ? (this.submitButtonText.textContent =
                  this.submitButton.dataset.originalText)
              : (this.submitButtonText.textContent =
                  window.variantStrings.addToCart);
        }
      }
      disconnectedCallback() {
        (this.buttonTextObserver && this.buttonTextObserver.disconnect(),
          document.removeEventListener(
            "variant:change",
            this.handleVariantChange,
          ));
      }
      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    },
  );
